// extracted by mini-css-extract-plugin
export default {"userDropdown":"UserDropdownMenu_userDropdown__4BmLg"};